import type { ArticleBlock } from "@/mocks/articles";

interface ArticleBodyProps {
  blocks: ArticleBlock[];
}

export default function ArticleBody({ blocks }: ArticleBodyProps) {
  return (
    <div className="space-y-6">
      {blocks.map((block, index) => {
        if (block.type === "heading") {
          return (
            <h3
              key={index}
              className="pt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl"
            >
              {block.text}
            </h3>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote
              key={index}
              className="border-l-4 border-accent-500 bg-background-100 px-5 py-4 font-heading text-base italic leading-relaxed text-foreground-800 md:text-lg"
            >
              {block.text}
            </blockquote>
          );
        }
        if (block.type === "image") {
          return (
            <figure key={index} className="space-y-2">
              <div className="overflow-hidden rounded-xl border border-background-200">
                <img
                  src={block.src}
                  alt={block.caption ?? "文章配图"}
                  title={block.caption ?? "台北娜娜文章配图"}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              {block.caption && (
                <figcaption className="text-center text-xs text-foreground-500">{block.caption}</figcaption>
              )}
            </figure>
          );
        }
        if (block.type === "video") {
          return (
            <div key={index} className="overflow-hidden rounded-xl border border-background-200">
              <div className="aspect-video w-full">
                <iframe
                  src={block.src}
                  title={block.caption ?? "视频内容"}
                  aria-label={block.caption ?? "视频内容"}
                  className="h-full w-full"
                  allowFullScreen
                />
              </div>
            </div>
          );
        }
        return (
          <p key={index} className="text-base leading-loose text-foreground-700">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}